<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <formWrapper :validator="$v.form">
        <form @submit.prevent="handleSubmit">
          <v-row>
            <v-col cols="12" md="6">
              <form-group name="name">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-model="form.name"
                    outlined
                    :label="$t('labels.name')"
                    v-on="listeners"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="phone.phone" attribute="label.phone.phone">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    type="number"
                    :label="$t('labels.phone')"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.phone.phone"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>

            <v-col cols="12" md="6">
              <form-group name="beneficiary_number">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    type="number"
                    v-bind="attrs"
                    v-model="form.beneficiary_number"
                    outlined
                    :label="$t('labels.beneficiary_number')"
                    @input="hadleChange('beneficiary_number')"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>

            <v-col cols="12" md="6">
              <form-group name="gender" attribute="fields.gender">
                <template slot-scope="{ attrs }">
                  <v-select
                    :items="genders"
                    item-text="text"
                    item-value="value"
                    v-bind="attrs"
                    v-model="form.gender"
                    outlined
                    :label="$t('labels.gender')"
                    @input="hadleChange('gender')"
                  ></v-select>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="country_id" attribute="fields.country_id">
                <template slot-scope="{ attrs, listeners }">
                  <v-autocomplete
                    autocomplete="off"
                    :items="countries"
                    item-text="name"
                    item-value="id"
                    v-bind="attrs"
                    v-on="listeners"
                    outlined
                    v-model="form.country_id"
                  >
                  </v-autocomplete>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="state_id" attribute="fields.state_id">
                <template slot-scope="{ attrs, listeners }">
                  <v-autocomplete
                    autocomplete="off"
                    :items="states"
                    item-text="name"
                    item-value="id"
                    v-bind="attrs"
                    v-on="listeners"
                    outlined
                    :disabled="states.length === 0"
                    v-model="form.state_id"
                  >
                  </v-autocomplete>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="city_id" attribute="fields.city_id">
                <template slot-scope="{ attrs, listeners }">
                  <v-autocomplete
                    autocomplete="off"
                    :items="cities"
                    item-text="name"
                    item-value="id"
                    v-bind="attrs"
                    v-on="listeners"
                    outlined
                    :disabled="cities.length === 0"
                    v-model="form.city_id"
                  >
                  </v-autocomplete>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="postal_code">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    type="number"
                    v-bind="attrs"
                    v-model="form.postal_code"
                    outlined
                    :label="$t('fields.postal_code')"
                    v-on="listeners"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group
                name="address_line_one"
                attribute="fields.address_line_one"
              >
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-model="form.address_line_one"
                    outlined
                    v-on="listeners"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.address_line_two"
                outlined
                :label="$t('labels.address_line_two')"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-menu
                :lang="locale"
                ref="menue"
                v-model="menue"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    v-model="form.birth_date"
                    :label="$t('fields.birthdate')"
                    hint="MM/DD/YYYY format"
                    persistent-hint
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <form-group name="birth_date" attribute="fields.birth_date">
                  <template slot-scope="{ attrs }">
                    <v-date-picker
                      :locale="locale"
                      v-bind="attrs"
                      :allowed-dates="allowedDates"
                      v-model="form.birth_date"
                      outlined
                      :label="$t('fields.birthdate')"
                      @input="(menue = false), hadleChange('birth_date')"
                    ></v-date-picker>
                  </template>
                </form-group>
              </v-menu>
            </v-col>

            <v-col cols="12">
              <form-group name="notes">
                <template slot-scope="{ attrs, listeners }">
                  <v-textarea
                    auto-grow
                    row-height="20"
                    v-bind="attrs"
                    v-model="form.notes"
                    outlined
                    :label="$t('labels.notes')"
                    v-on="listeners"
                  ></v-textarea>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12">
              <v-btn
                block
                large
                type="submit"
                class="primary"
                :disabled="$v.form.$invalid"
                :loading="btnLoading"
                >{{ $t("button.save") }}</v-btn
              >
            </v-col>
          </v-row>
        </form>
      </formWrapper>
    </v-container>
  </main>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import {
  StoreData,
  UpdateData,
  ShowData,
  UpdateMedia,
  IndexData,
} from "@/helpers/apiMethods";
import { SaudiPhonNumber } from "@/utils/validate";

import { maxWords } from "@/utils/validate";

export default {
  name: "FormComponent",
  components: {
    fileUpload: () => import("@/components/fileUpload"),
  },

  data() {
    return {
      locale: this.locale,
      inputLoading: false,

      form: {
        beneficiary_number: "",
        name: "",
        notes: "",
        birth_date: "",
        gender: "",
        phone: {
          phone: "",
          country_code: "00966",
        },
        country_id: "",
        city_id: "",
        state_id: "",
        address_line_one: "",
        postal_code: "",
      },

      genders: [
        { value: 1, text: this.$t("label.male") },
        { value: 2, text: this.$t("label.female") },
      ],

      imageFile: "",
      maxsize: 4,
      btnLoading: false,
      menue: false,
      inputChange: false,
      beneficiary: {},
      countries: [],
      states: [],
      cities: [],
    };
  },

  methods: {
    getCountiers() {
      IndexData({ reqName: "countries", query: { pagination: "all" } }).then(
        (res) => {
          const { data } = res.data;
          this.countries = data;
        }
      );
    },
    getStatesAndCities() {
      const fields = ["states", "cities"];
      for (const field of fields) {
        IndexData({
          reqName: `countries/${this.form.country_id}/${field}`,
          query: { pagination: "all" },
        }).then((res) => {
          const { data } = res.data;
          this[field] = data;
        });
      }
    },

    allowedDates(date) {
      const pickerDate = new Date(date);
      const currentDate = Date.now();
      return pickerDate < currentDate;
    },

    fireLocaleChange(locale) {
      this.locale = locale;
      this.handleShow(locale);
    },

    handleShow(locale) {
      ShowData({
        reqName: "beneficiaries",
        param: this.$route.params.id,
        locale,
      })
        .then((res) => {
          const { beneficiary } = res.data;
          this.beneficiary = beneficiary;
          this.form = {
            ...beneficiary,
            phone: {
              phone: beneficiary.phone.phone,
              country_code: beneficiary.phone.country_code,
            },
            birth_date: beneficiary.birth_date ? beneficiary.birth_date : "",
            country_id: beneficiary.address.country.id,
            state_id: beneficiary.address.state.id,
            city_id: beneficiary.address.city.id,
            postal_code: beneficiary.address.postal_code,
            address_line_one: beneficiary.address.address_line_one,
            address_line_two: beneficiary.address.address_line_two
              ? beneficiary.address.address_line_two
              : "",
          };
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // x2
    buildData() {
      let formData = new FormData();

      Object.keys(this.form).map((key) => {
        if (key !== "phone" && key !== "address") {
          formData.append(key, this.form[key]);
        }
      });
      formData.append("phone[phone]", this.form.phone.phone);
      formData.append("phone[country_code]", "00966");
      formData.append("address[country_id]", this.form.country_id);
      formData.append("address[state_id]", this.form.state_id);
      formData.append("address[city_id]", this.form.city_id);
      formData.append("address[postal_code]", this.form.postal_code);
      formData.append("address[address_line_one]", this.form.address_line_one);
      formData.append("address[address_line_two]", this.form.address_line_two);

      if (!this.form.gender) {
        formData.delete("gender");
      }
      formData.append("locale", this.locale);
      if (this.isEdited) {
        formData.append("_method", "put");
      }
      return formData;
    },
    createMethod() {
      this.btnLoading = true;
      const formData = this.buildData();

      StoreData({ reqName: "beneficiaries", data: formData })
        .then((res) => {
          const { beneficiary } = res.data;
          this.beneficiary = beneficiary;
          this.$router.push("/beneficiaries");
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    editMethod() {
      this.btnLoading = true;

      UpdateData({
        reqName: "beneficiaries",
        data: this.buildData(),
        param: this.$route.params.id,
      })
        .then((res) => {
          if (res) {
            this.$router.push("/beneficiaries");
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },

    handleSubmit() {
      if (this.$route.name == "create-beneficiaries") {
        // in case create
        this.createMethod();
      } else {
        // in case Edit
        this.editMethod();
      }
    },

    hadleChange(name) {
      this.$v.form[name].$touch();
      this.inputChange = true;
    },

    reset() {
      this.$v.form.$reset();
      this.form = {};
      this.inputChange = false;
      this.btnLoading = false;
      this.$store.dispatch("ClearServerErrors");
    },
  },
  validations: {
    form: {
      country_id: {
        required,
      },
      state_id: {
        required,
      },
      city_id: {
        required,
      },
      address_line_one: {
        required,
      },
      postal_code: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(5),
      },
      phone: {
        phone: {
          SaudiPhonNumber,
        },
      },
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      beneficiary_number: {
        required,
        numeric,
      },
      gender: {
        numeric,
      },
      birth_date: {},
      notes: {
        minLength: minLength(3),
        maxWords: maxWords(50),
      },
    },
  },
  computed: {
    isEdited() {
      if (this.$route.params.id) {
        return true;
      } else {
        return false;
      }
    },
    formTitle() {
      if (!this.$route.params.id) {
        return this.$t("heading.create");
      } else {
        return this.$t("heading.edit");
      }
    },
  },
  watch: {
    $route: {
      handler({ params, query }) {
        this.getCountiers();
        if (params.id) {
          this.handleShow();
        }
      },
      immediate: true,
    },
    "form.country_id": {
      handler(value) {
        if (value) {
          this.getStatesAndCities();
        }
      },
      immediate: true,
    },
  },
};
</script>
